"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.LocaleData = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        globalContainer = window;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    connectToData: function () { return t('@tableau__predictive-model-ui/connectToData'); },
    defineObjective: function () { return t('@tableau__predictive-model-ui/defineObjective'); },
    trainModel: function () { return t('@tableau__predictive-model-ui/trainModel'); },
    modelResults: function () { return t('@tableau__predictive-model-ui/modelResults'); },
    deployModel: function () { return t('@tableau__predictive-model-ui/deployModel'); },
    clickToConnect: function () { return t('@tableau__predictive-model-ui/clickToConnect'); },
    clickToDefine: function () { return t('@tableau__predictive-model-ui/clickToDefine'); },
    clickToTrain: function () { return t('@tableau__predictive-model-ui/clickToTrain'); },
    modelNotRun: function () { return t('@tableau__predictive-model-ui/modelNotRun'); },
    clickToDeploy: function () { return t('@tableau__predictive-model-ui/clickToDeploy'); },
    chooseTargetTitle: function () { return t('@tableau__predictive-model-ui/chooseTargetTitle'); },
    chooseTargetDescription: function () { return t('@tableau__predictive-model-ui/chooseTargetDescription'); },
    salesforceDatasourceIdListTitle: function () { return t('@tableau__predictive-model-ui/salesforceDatasourceIdListTitle'); },
    outcomeFieldListTitle: function () { return t('@tableau__predictive-model-ui/outcomeFieldListTitle'); },
    selectOutcomeField: function () { return t('@tableau__predictive-model-ui/selectOutcomeField'); },
    fieldTooltip: function () { return t('@tableau__predictive-model-ui/fieldTooltip'); },
    goalListTitle: function () { return t('@tableau__predictive-model-ui/goalListTitle'); },
    goalTooltip: function () { return t('@tableau__predictive-model-ui/goalTooltip'); },
    modelAlgorithmTitle: function () { return t('@tableau__predictive-model-ui/modelAlgorithmTitle'); },
    algorithmTooltip: function () { return t('@tableau__predictive-model-ui/algorithmTooltip'); },
    forNextStepDescription: function () { return t('@tableau__predictive-model-ui/forNextStepDescription'); },
    nextStepButton: function () { return t('@tableau__predictive-model-ui/nextStepButton'); },
    startTrainingButton: function () { return t('@tableau__predictive-model-ui/startTrainingButton'); },
    aucTooltip: function () { return t('@tableau__predictive-model-ui/aucTooltip'); },
    minLabel: function () { return t('@tableau__predictive-model-ui/minLabel'); },
    maxLabel: function () { return t('@tableau__predictive-model-ui/maxLabel'); },
    modelAccuracytitle: function () { return t('@tableau__predictive-model-ui/modelAccuracytitle'); },
    evaluationButtonLabel: function () { return t('@tableau__predictive-model-ui/evaluationButtonLabel'); },
};
//# sourceMappingURL=Localize.js.map